function updateNestedProperty(obj, path, value) {
    const keys = path.split('.');
    const lastKey = keys.pop();

    // Traverse the object to the specified nested property
    const nestedObject = keys.reduce((nested, key) => nested[key], obj);

    // Update the nested property with the new value
    nestedObject[lastKey] = value;

    return { ...obj };
};

function getKeyByValue(object, value) {
    return Object.keys(object).find(key => object[key] === value);
};

export {
    updateNestedProperty,
    getKeyByValue
}